/* eslint-disable prettier/prettier */
import React from 'react'
import { CFooter } from '@coreui/react-pro'

const AppFooter = () => {
  return (
    <CFooter className="px-4 mt-3">
      <div>
        <span className="ms-1">&copy; 2024 AIMC -  All Rights Reserved</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        {/* <a
          
          target="_blank"
          rel="noopener noreferrer"
        > */}
        AIMC
        {/* </a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
